<template>
  <div class="data-container">
    <div class="data_item" v-for="(item,index) in downList" :key="index">
      <span>{{item.title}}</span>
      <div>
        <a
          href="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/exhibitor/2025%E5%B9%BF%E5%B7%9E%E8%BD%A6%E5%B1%95%E6%8B%9B%E5%B1%95%E5%87%BD.pdf"
          target="_blank"
        >立即下载/Download</a>
      </div>
      
    </div>
    <div class="video_wrap">
      <div class="title">
        <h2 class="media_font_size_70">广州国际车展</h2>
        <span>AUTOSHOW</span>
      </div>
      <video
        src="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/gz_19_video.mp4"
        controls
      ></video>
    </div>
    <div class="news_wrap">
      <div class="title">
        <h2 class="media_font_size_70">展会新闻</h2>
        <span>NEWS</span>
      </div>
      <div class="news_container">
        <div class="news_item" v-for="(item,index) in newsList" :key="index">
          <div :style="{'backgroundImage':'url('+item.img+')'}"></div>
          <span class="item_title media_font_size_50">{{item.title}}</span>
          <span class="item_date media_font_size_30">{{item.date}}</span>
        </div>
      </div>
      <div class="default_btn media_font_size_50" @click="handelJump('/newsCenter?tab=0')">查看更多</div>
    </div>
    <div class="map_wrap">
      <img src="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/map.png" alt />
    </div>
    <div class="co_wrap">
      <div class="title">
        <h2 class="media_font_size_70">合作媒体</h2>
        <span class="mb_80">MEDIA</span>
      </div>
      <div class="swiper-container coswiper">
        <swiper :options="swiperOption" class="swiper" ref="mySwiper">
          <swiper-slide class="slide" v-for="(item,index) in logoList" :key="index">
            <img :src="item.img" alt />
            <!-- <div class="slide_item" :style="{'backgroundImage':'url('+item.img+')'}"></div> -->
          </swiper-slide>
        </swiper>
      </div>
      <div class="default_btn media_font_size_50">查看更多</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      downList: [
        {
          title: "2024广州车展招展函",
          url: ""
        },
        // {
        //   title: "2021广州车展投标文件",
        //   url: ""
        // }
      ],
      logoList: [
        {
          id: "1",
          img:
            "http://autoguangzhou.com.cn/uploadfiles/2020/11/202011101357455745.jpg",
          url: ""
        },
        {
          id: "2",
          img:
            "http://autoguangzhou.com.cn/uploadfiles/2020/10/202010101442494249.jpg",
          url: ""
        },
        {
          id: "3",
          img:
            "http://autoguangzhou.com.cn/uploadfiles/2019/11/201911051345254525.jpg",
          url: ""
        },
        {
          id: "4",
          img:
            "http://autoguangzhou.com.cn/uploadfiles/2019/09/20190926160832832.png",
          url: ""
        },
        {
          id: "5",
          img:
            "http://autoguangzhou.com.cn/uploadfiles/2019/09/20190926160736736.png",
          url: ""
        },
        {
          id: "6",
          img:
            "http://autoguangzhou.com.cn/uploadfiles/2018/11/201811081446324632.jpg",
          url: ""
        },
        {
          id: "7",
          img:
            "http://autoguangzhou.com.cn/uploadfiles/2018/11/20181102180620620.png",
          url: ""
        },
      ],
      newsList: [
        {
          title:
            "新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题",
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/newscover.jpeg",
          date: "2020-11-22"
        },
        {
          title: "新闻标题",
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/newscover.jpeg",
          date: "2020-11-22"
        },
        {
          title: "新闻标题",
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/newscover.jpeg",
          date: "2020-11-22"
        }
      ],
      swiperOption: {
        // 所有的参数同 swiper 官方 api 参数
        direction: "horizontal",
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        slidesPerView: 5,
        spaceBetween: 40,
        autoHeight: true,
        autoplay: 3000,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  methods: {
    handelPre() {},
    handelNext() {},
    handelJump(path){
      this.$router.push(path)
    }
  }
};
</script>

<style lang="scss">
.data-container {
  width: 1200px;
  .data_item {
    width: 1200px;
    height: 120px;
    background: rgba($color: #fff, $alpha: 0.2);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 30px;
    box-sizing: border-box;
    margin-bottom: 30px;
    > span {
      font-size: 36px;
      color: #fff;
    }
    > div {
      // width: 200px;
      // height: 60px;
      padding:5px 20px;
      background: #42abff;
      border-radius: 30px;
      font-size: 24px;
      color: #fff;
      // line-height: 65px;
      text-align: center;
       >a{
      color: #fff;
    }
    }
  }
  .desc_wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #fff;
    margin-bottom: 102px;
    > span {
      color: rgba($color: #fff, $alpha: 0.5);
      font-size: 24px;
    }
  }
  .video_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;

    > video {
      width: 1200px;
      margin-top: 49px;
    }
  }
  .news_wrap {
    margin-top: 99px;
    .news_container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .news_item {
        display: flex;
        flex-direction: column;
        color: #fff;
        > div {
          width: 370px;
          height: 260px;
          background-size: cover;
          background-position: center;
        }
        .item_title {
          color: #fff;
          width: 370px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 26px 0px 50px 0px;
          font-size: 22px;
        }
        .item_date {
          font-size: 16px;
          color: rgba($color: #fff, $alpha: 0.5);
        }
      }
    }
  }
  .map_wrap {
    display: flex;
    margin: 120px 0px;
    > img {
      width: 100%;
      height: 908px;
    }
  }
  .co_wrap {
    .swiper-container {
      height: 100px;

      .swiper {
        height: 80px;
        .slide {
          width: 125px;
          height: 70px;
          > img {
            width: 100%;
            height: 100%;
          }
          .slide_item {
            // width: 100%;
            height: 100px;
            background: #fff;
            background-size: cover;
            background-position: center;
          }
        }
      }
    }
  }
}

.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  > h2 {
    font-size: 36px;
  }
  > span {
    color: rgba($color: #fff, $alpha: 0.5);
  }
}
.default_btn {
  background: rgba($color: #fff, $alpha: 0.2);
  border-radius: 30px;
  padding:18px;
  text-align: center;
  color: rgba($color: #fff, $alpha: 0.5);
  font-size: 24px;
  margin: 60px auto;
  width: 300px;
}
.mb_80 {
  margin-bottom: 80px;
}
</style>


// WEBPACK FOOTER //
// dataDown.vue?b925d3d4